export default __webpack_public_path__ + "static/media/SWT0210.34I-20549_-16353_0.326f3367.jpg";